<template>
  <v-container id="login" fill-height fluid style="overflow=hidden;">
    <v-layout      
      align-center
      justify-center
      row
      fill-height
    >
      <v-flex xs10 md6 lg4>
        <v-card>
          <v-container>
            <router-view></router-view>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: "authentication"
};
</script>
<style scoped>
#login {
  background-image: url(https://picsum.photos/1200/?random&blur);
  background-size: cover;
}
</style>
